import { AddressesAddressBookDto } from "@springtree/eva-services-core";
import { useTranslations } from "next-intl";

import IconHeart from "@/icons/icon-heart";

import Dialog from "../../common/dialog";
import Icon from "../../common/icon";
import AddressForm from "./address-form";
import styles from "./address-list.module.scss";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onAfterOpen?: () => void;
  onAfterClose?: () => void;
  address: AddressesAddressBookDto;
  onAfterSubmit: () => void;
};

export default function EditAddressDialog(props: Props) {
  const t = useTranslations();

  return (
    <Dialog
      isOpen={props.isOpen}
      title={
        <>
          <Icon icon={IconHeart} />
          <span>{t("generic.myaccount.address.edit_address_title")}</span>
        </>
      }
      onClose={props.onClose}
      onAfterOpen={props.onAfterOpen}
      onAfterClose={props.onAfterClose}
      customStyles={styles}
    >
      <AddressForm address={props.address} onAfterSubmit={props.onAfterSubmit} noWrapper />
    </Dialog>
  );
}
